import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { TextVideo4_Maria } from '../../../../../utils/ES/Modals/directors';

const ModalVideoMaria4 = () => {
  return (
    <>
      <ModalVideo
        id="maria-video-4"
        dataText={TextVideo4_Maria}
        videoSrc="https://player.vimeo.com/video/637649826?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_DIRECTORS_MARIA_4"
      />
    </>
  );
};

export default ModalVideoMaria4;
